import { Alpine as AlpineType } from 'alpinejs';

export default (Alpine: AlpineType) => {
  Alpine.data('productQuality', (props: any) => ({
    current: 0,

    get headers() {
      return Object.values(props?.data?.headers || {});
    },
    get rows() {
      return props?.data?.body.map((item: any) => ({ ...item, columns: Object.values(item.columns) })) || [];
    },
    get last() {
      return this.headers.length - 1;
    }
  }));
};
